<template>
  <v-chip
    label
    small
    dark
    :color="organisation ? organisation.color : 'grey darken-2'"
  >
    {{ organisation ? organisation.name : 'Both companies' }}
  </v-chip>
</template>

<script>
export default {
  name: 'OrganisationChip',
  props: {
    organisation: {
      type: Object,
      default: () => undefined
    }
  }
}
</script>
